angular.module('hj.nearBottom', []).directive('hjNearBottom', ['$rootScope', '$window', '$timeout',
    function($rootScope, $window, $timeout) {
        'use strict';
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                var throttle = function(func, wait, options) {
                    var context, args, result;
                    var timeout = null;
                    var previous = 0;
                    if (!options) {
                        options = {};
                    }
                    var later = function() {
                        previous = options.leading === false ? 0 : Date.now();
                        timeout = null;
                        result = func.apply(context, args);
                        if (!timeout) {
                            context = args = null;
                        }
                    };
                    return function() {
                        var now = Date.now();
                        if (!previous && options.leading === false) {
                            previous = now;
                        }
                        var remaining = wait - (now - previous);
                        context = this;
                        args = arguments;
                        if (remaining <= 0 || remaining > wait) {
                            if (timeout) {
                                $timeout.cancel(timeout);
                                timeout = null;
                            }
                            previous = now;
                            result = func.apply(context, args);
                            if (!timeout) {
                                context = args = null;
                            }
                        } else if (!timeout && options.trailing !== false) {
                            timeout = $timeout(later, remaining);
                        }
                        return result;
                    };
                };

                var scroll = function() {
                    var scrollPercent = $window.scrollY / ($element[0].scrollHeight - $window.innerHeight);

                    if (scrollPercent > Number($attrs.hjNearBottom || 0.9)) {
                        $rootScope.$broadcast('hjNearBottom');

                        $element.addClass('hj-near-bottom');

                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }

                    } else {
                        $element.removeClass('hj-near-bottom');
                    }
                };

                var throttledScroll = throttle(scroll, 300, {
                    leading: true
                });

                angular.element($window).on('scroll', throttledScroll);

                $scope.$on('$destroy', function() {
                    angular.element($window).off('scroll', throttledScroll);
                });
            }
        };
    }
]);
